<template>
  <div class="system-tech-area">
    <div class="system-title system-title-bg">新闻资讯</div>
    <router-view/>
  </div>
</template>

<script>
import constants from "@/api/constants";
import { computed } from "vue";
import NewsItemsView from "@/views/NewsItemsView";

export default {
  name: "NewsPage",
  components: { NewsItemsView },
  setup() {
    const newsItemData = computed(() => {
      return constants.newsItemData;
    });
    return {
      newsItemData
    };
  }
};
</script>

<style scoped>
.system-tech-area {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.system-title {
  color: white;
  font-size: 50px;
  width: 100%;
  text-align: center;
  padding-top: 170px;
}

.system-title-bg {
  height: 350px;
  background-image: url("./../assets/images/news_title_bg.png");
}


</style>
